export const isThereAnActiveTrial = (organization) => {
  if (organization) {
    const now = Date.now();
    if (now <= organization.trial_end_timestamp) return true;
  }
  return false;
};
